var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-footer" },
    [
      _c("AppDropdown", {
        staticClass: "app-footer__language",
        attrs: {
          "display-prop": "text",
          value: _vm.selectedLanguage,
          options: _vm.languages,
          required: ""
        },
        on: { input: _vm.setLanguage },
        scopedSlots: _vm._u([
          {
            key: "selected",
            fn: function(ref) {
              var props = ref.props
              return [
                _c("span", { staticClass: "option-text" }, [
                  _vm._v("\n\t\t\t\t" + _vm._s(props.option.text) + "\n\t\t\t")
                ])
              ]
            }
          },
          {
            key: "option",
            fn: function(ref) {
              var props = ref.props
              return [
                _c("span", { staticClass: "option-text" }, [
                  _vm._v("\n\t\t\t\t" + _vm._s(props.option.text) + "\n\t\t\t")
                ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("ul", { staticClass: "links" }, [
        _c("li", { staticClass: "links__link" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.upmood.com/termsconditions",
                target: "_blank"
              }
            },
            [
              _vm._v(
                "\n\t\t\t\t" + _vm._s(_vm.$t("terms_condition")) + "\n\t\t\t"
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "links__link" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.upmood.com/privacypolicy",
                target: "_blank"
              }
            },
            [
              _vm._v(
                "\n\t\t\t\t" + _vm._s(_vm.$t("privacy_policy")) + "\n\t\t\t"
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d5fcbff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d5fcbff","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppFooter.vue
// module id = null
// module chunks = 